<div class="accordion-item mb-3" [class.open]="isOpen()">
  <h2 class="accordion-header" [id]="headingId()">
    <button
      class="accordion-button"
      [class.collapsed]="!isOpen()"
      type="button"
      [attr.aria-expanded]="isOpen()"
      [attr.aria-controls]="collapseId()"
      (click)="toggle()"
    >
      <!-- Icono izquierdo -->
      @if (iconType() !== 'none') {
        <span class="acc-icon" [class]="iconStatus()" aria-hidden="true">
          @switch (iconType()) {
            @case ('check') {
              <img src="./assets/img/svg/check_circle.svg" alt="Ícono de check" />
            }
            @case ('warning') {
              <img src="./assets/img/svg/Check_círculo.svg" alt="Ícono de warm" />
            }
            @case ('error') {
              <img src="./assets/img/error-circle.svg" alt="Ícono de error" />
            }
            @case ('info') {
              <img src="./assets/img/svg/Documento.svg" alt="Ícono de información" />
            }
          }
        </span>
      }

      <!-- Título + descripción colapsada -->
      <div class="acc-button-content">
        <h3 class="acc-title">{{ title() }}</h3>
        @if (description()) {
          <span class="acc-desc" [innerHTML]="description()"></span>
        }
      </div>

      <!-- Chevron (rota via CSS según .collapsed) -->
      <span class="acc-chevron" aria-hidden="true">
        <img src="./assets/img/svg/Avant_abajo.svg" width="24" height="24" alt="Ícono de éxito" />
      </span>
    </button>
  </h2>

  <!-- div.accordion-collapse (espeja Bootstrap: .collapse + .show) -->
  <div class="accordion-collapse collapse" [class.show]="isOpen()" [id]="collapseId()" [attr.aria-labelledby]="headingId()">
    <!-- div.accordion-body -->
    <div class="accordion-body">
      @if (items().length > 0) {
        <ul class="acc-list">
          @for (item of items(); track item.label) {
            <div class="acc-row">
              <li class="acc-lbl">{{ item.label }}</li>
              <li class="acc-val">{{ item.value }}</li>
            </div>
          }
        </ul>
      } @else {
        <ng-content />
      }
    </div>
  </div>
</div>
